export const API_URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ?
    "https://localhost:5001" :
    "https://sbk24.pl";


// export const API_URL = "http://o-wiszowaty";
// export const API_URL = "http://profi24.profidata.com.pl";
// export const API_URL = "https://sbk24.pl";
